import type { Canvas } from "fabric";
import { useDebouncedFunction } from "../../../../../../hooks/useDebouncedFunction.ts";
import { useOn } from "../../../../../../hooks/useOn.ts";
import { useCanvasEventsListener } from "./useCanvasEventsListener.ts";

export const useCanvasHistoryKeyboardShortcut = ({
  fabricCanvas,
  saveHistorySnapshot,
  undo,
  redo,
}: {
  fabricCanvas: Canvas | undefined;
  saveHistorySnapshot: () => void;
  undo: () => Promise<void>;
  redo: () => Promise<void>;
}) => {
  useOn("keydown", ({ key, ctrlKey, metaKey, shiftKey }) => {
    if (fabricCanvas === undefined) return;
    if (key.toLowerCase() === "z" && (ctrlKey || metaKey) && !shiftKey) {
      void undo();
    }
    if (key.toLowerCase() === "z" && (ctrlKey || metaKey) && shiftKey) {
      void redo();
    }
  });

  const debouncedSaveHistorySnapshot = useDebouncedFunction(
    saveHistorySnapshot,
    50,
  );

  useCanvasEventsListener({
    eventTypes: [
      "object:added",
      "object:removed",
      "object:modified",
      "object:moving",
      "object:scaling",
      "object:rotating",
      "object:skewing",
      "canvas:cleared",
      "background:color:changed",
      "canvas:size:changed",
      "layer:text:changed",
      "layer:text:selection:changed",
      "layer:shape:changed",
      "layer:rect:changed",
      "layer:line:changed",
      "layer:image:changed",
      "layer:image:contentUuid:changed",
    ],
    onEvent: debouncedSaveHistorySnapshot,
    canvas: fabricCanvas,
  });
};
